import React, { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import { Jumbotron, Container, Row, Col, Button, Table } from 'react-bootstrap';
import { HomeCard } from '../Components/HomeCard';
import MainClassImg from '../images/MainClass.jpg';
import ExtraClassImg from '../images/ExtraClass.jpg';
import BooksImg from '../images/Books.jpg';
import { useParams, withRouter } from 'react-router-dom';
import { storeContext } from '../Store/storeContext';
const Home = (props) => {
  let { role, name } = useParams();

  console.log(role, name);
  const [link, setLink] = useState('');
  const [announcements, setAnnouncements] = useState([]);
  const [, dispatch] = useContext(storeContext);
  const _getEntries = () => {
    try {
      Axios({
        url: '/.netlify/functions/fetchForm',
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(localStorage.getItem('tokens')).access.token,
          credentials: 'include',
        },
        params: { cr: role },
      })
        .then((response) => {
          if (response.data.form) {
            
            setLink(response.data.form[0].link);
          }
          setAnnouncements(response.data.announcements);
        })
        .catch(console.error);
      dispatch({
        type: 'SET_CURRENT_COURSE',
        payload: `/home/${role}/${name}`,
      });
    } catch {
      window.location.href = '/';
    }
  };
  useEffect(_getEntries, []);

  return (
    <Container className='py-4'>
      <Jumbotron fluid className='shadow-sm bg-custom-3'>
        <Container>
          <h1 className='text-center'>{name}</h1>
          <p className='text-center'>
            It’s not that I’m so smart, it’s just that I stay with problems
            longer” – Albert Einstein
          </p>
        </Container>
      </Jumbotron>
      <Row>
        <Col md={4}>
          <HomeCard
            bgImg={MainClassImg}
            name={'Main Class'}
            link={`/mainclass/${role}`}
          />
        </Col>
        <Col md={4}>
          <HomeCard
            bgImg={ExtraClassImg}
            name={'Extra Class'}
            link={`/extraclass/${role}`}
          />
        </Col>
        <Col md={4}>
          <HomeCard
            bgImg={BooksImg}
            name={'Notes and Books'}
            link={`/notesbooks/${role}`}
          />
        </Col>
      </Row>
      <Row>
        <Col md={7}>
          {link ? (
            <Jumbotron className='bg-custom-4 text-white shadow-sm p-2'>
              <h5>Submit Your Tasks Here</h5>
              <hr />
              <p>
                Follow the instructions written in the form to upload your task,
                make sure to upload before due date mentioned on the right side.
              </p>
              <a rel='noreferrer' target='_blank' href={link}>
                <Button variant='light'>Open Form Link</Button>
              </a>
            </Jumbotron>
          ) : null}
        </Col>
        <Col md={5}>
          <Jumbotron className='bg-custom-4 text-white shadow-sm p-2'>
            <h5>Notice Board</h5>
            <hr />
            <Table className='text-white' striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {announcements
                  ? announcements.map((elem, index) => {
                      return (
                        <tr>
                          <td>{elem.name}</td>
                          <td>{new Date(elem.date).toLocaleString()} PST</td>
                        </tr>
                      );
                    })
                  : null}
              </tbody>
            </Table>
          </Jumbotron>
        </Col>
      </Row>
    </Container>
  );
};

export default withRouter(Home);
